import {
  calendar_year_picker_styles_default
} from "./chunk.UMVGDPU4.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/calendar/calendar-year-picker.ts
import { t as t2 } from "i18next";
var yearsPerPage = 24;
var FadvCalendarYearPicker = class extends s {
  constructor() {
    super(...arguments);
    this.mode = "year";
    this.keyboardSelection = false;
    this.years = [];
  }
  initialize() {
    const activeYear = this.state.workingDate.getFullYear();
    const minYearOfPage = activeYear - this.getActiveOffset(this.state.workingDate);
    this.years.length = 0;
    for (let i = 0; i < yearsPerPage; i++) {
      this.years.push(minYearOfPage + i);
    }
  }
  getActiveOffset(activeDate) {
    const activeYear = activeDate.getFullYear();
    return this.euclideanModulo(activeYear - this.getStartingYear(), yearsPerPage);
  }
  getStartingYear() {
    let startingYear = 0;
    if (this.state.maxDate) {
      const maxYear = this.state.maxDate.getFullYear();
      startingYear = maxYear - yearsPerPage + 1;
    } else if (this.state.minDate) {
      startingYear = this.state.minDate.getFullYear();
    }
    return startingYear;
  }
  euclideanModulo(a, b) {
    return (a % b + b) % b;
  }
  handleKeydown(event) {
    const year = this.state.workingDate.getFullYear();
    let yearDiff = 0;
    switch (event.key) {
      case "ArrowUp":
        yearDiff = -4;
        break;
      case "ArrowDown":
        yearDiff = 4;
        break;
      case "ArrowLeft":
        yearDiff = -1;
        break;
      case "ArrowRight":
        yearDiff = 1;
        break;
      case "Home":
        yearDiff = 1 - year;
        break;
      case "End":
        yearDiff = yearsPerPage - year;
        break;
      case "PageUp":
        yearDiff = event.altKey ? -yearsPerPage * 10 : -yearsPerPage;
        break;
      case "PageDown":
        yearDiff = event.altKey ? yearsPerPage * 10 : yearsPerPage;
        break;
      default:
        return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.keyboardSelection = true;
    const nextWorkingDate = new Date(this.state.workingDate.setFullYear(year + yearDiff));
    this.emitDateChange(nextWorkingDate);
    requestAnimationFrame(() => this.focus());
  }
  handleNextClick() {
    this.keyboardSelection = false;
    this.emitDateChange(new Date(this.state.workingDate.setFullYear(this.years[this.years.length - 1] + 1)));
  }
  handlePrevClick() {
    this.keyboardSelection = false;
    this.emitDateChange(new Date(this.state.workingDate.setFullYear(this.years[0] - 1)));
  }
  createYearClickHandler(year, isDisabled) {
    return () => {
      if (isDisabled)
        return;
      this.keyboardSelection = false;
      this.emitDateChange(new Date(year, this.state.workingDate.getMonth(), this.state.workingDate.getDate()), "month");
    };
  }
  emitDateChange(date, mode) {
    emit(this, "fadv-date-changed", { detail: { date, mode } });
  }
  getNavigatorLabel() {
    return `${this.years[0]} - ${this.years[this.years.length - 1]}`;
  }
  focus(options) {
    var _a, _b;
    const year = this.state.workingDate.getFullYear();
    (_b = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(`button[aria-label="${year}"]`)) == null ? void 0 : _b.focus(options);
  }
  handleLabelClick() {
    emit(this, "fadv-cal-nav-mode-change");
  }
  renderYear(year, minYear, maxYear) {
    var _a;
    const isCurrent = year === this.state.currentDate.getFullYear();
    const isSelected = year === ((_a = this.state.selectedDate) == null ? void 0 : _a.getFullYear());
    const workingYear = this.state.workingDate.getFullYear();
    const isDisabled = year > maxYear || year < minYear;
    return $`<button class=${o({
      "calendar-year-picker__year": true,
      "calendar-year-picker__year-current": isCurrent,
      "calendar-year-picker__year-selected": isSelected,
      "calendar-year-picker__active": this.keyboardSelection && year === workingYear,
      "calendar-year-picker__disabled": isDisabled
    })} @click=${this.createYearClickHandler(year, isDisabled)} role="gridcell" aria-label="${year}" tabindex=${year === workingYear ? "0" : "-1"} ><fadv-typography type="label-medium">${year}</fadv-typography></button>`;
  }
  render() {
    var _a, _b, _c;
    this.initialize();
    let minDate = this.state.minDate;
    if (minDate) {
      minDate = new Date(minDate);
      minDate = new Date(minDate.setSeconds(minDate.getSeconds() + 1));
    }
    const minYear = (_a = minDate == null ? void 0 : minDate.getFullYear()) != null ? _a : Number.MIN_SAFE_INTEGER;
    const maxYear = (_c = (_b = this.state.maxDate) == null ? void 0 : _b.getFullYear()) != null ? _c : Number.MAX_SAFE_INTEGER;
    return $`<div class="calendar-year-picker"><div class="calendar-navigator"><div class="calendar-navigator__title"><button aria-label=${t2("components:calendar.chooseDate")} @click=${this.handleLabelClick}><fadv-typography aria-label=${t2("components:calendar.chooseDate")} variant="primary" type="heading-small" weight="500">${this.getNavigatorLabel()}</fadv-typography></button></div><div class="calendar-navigator__controls"><button aria-label=${t2("components:calendar.yearsPrevious", { years: yearsPerPage })} @click=${this.handlePrevClick}><fadv-icon size="small" foreground="primary" library="solid" name="fa-chevron-left"></fadv-icon></button><button aria-label=${t2("components:calendar.yearsNext", { years: yearsPerPage })} @click=${this.handleNextClick}><fadv-icon size="small" foreground="primary" library="solid" name="fa-chevron-right"></fadv-icon></button></div></div><div role="grid" class="calendar-year-picker__years" @keydown=${this.handleKeydown}>${this.years.map((year) => this.renderYear(year, minYear, maxYear))}</div></div>`;
  }
};
FadvCalendarYearPicker.styles = calendar_year_picker_styles_default;
__decorateClass([
  t()
], FadvCalendarYearPicker.prototype, "state", 2);
__decorateClass([
  t()
], FadvCalendarYearPicker.prototype, "keyboardSelection", 2);
FadvCalendarYearPicker = __decorateClass([
  n("fadv-calendar-year-picker")
], FadvCalendarYearPicker);

export {
  FadvCalendarYearPicker
};
